import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { MicroCart } from "@ecom/components/MicroCart";

registerExtension("_site.route.menu.shoppingCart", MicroCart, "ShoppingCartMicroCart");
